import routeName from '@/router/constant';
import { guideRoutes } from '@/utils/guideRoutes';

const typeName = '3';
const code = 'A3';
const backPage = routeName.CONTACT_INFO;

export const a3Header = [
    {
        path: `${typeName}-policy-list`,
        name: routeName.A3_SELECT_POLICY,
        component: () => import('@/views/policy/Index.vue'),
        meta: {
            auth: true,
            metaTitle: '給付帳號約定',
            pageTitle: '給付帳號約定',
            backPage,
            code,
            unableBack: true,
        },
        beforeEnter: (to, from, next) => {
            const whiteList = [routeName.CONTACT_INFO, routeName.FINISH];
            const guideRoute = guideRoutes(from, whiteList, true);
            next(guideRoute);
        },
    },
];
export const a3Step = [
    {
        path: `${typeName}-set-account`,
        name: routeName.A3_SET_ACCONT,
        component: () => import('@/views/a3/landingPage/Index.vue'),
        meta: {
            auth: true,
            metaTitle: '給付帳號約定',
            pageTitle: '給付帳號約定',
            backPage,
            code,
            isNeedPolicyCard: true,
            unableBack: true,
        },
        beforeEnter: (to, from, next) => {
            const whiteList = [routeName.A3_SELECT_POLICY, routeName.A3_CONFIRM];
            const guideRoute = guideRoutes(from, whiteList, true);
            next(guideRoute);
        },
    },
    {
        path: `${typeName}-confirm`,
        name: routeName.A3_CONFIRM,
        component: () => import('@/views/a3/dataConfirm/Index.vue'),
        meta: {
            auth: true,
            metaTitle: '給付帳號約定',
            pageTitle: '給付帳號約定',
            backPage: routeName.A3_SET_ACCONT,
            code,
            isNeedPolicyCard: true,
            unableBack: true,
        },
        beforeEnter: (to, from, next) => {
            const whiteList = [routeName.A3_SET_ACCONT];
            const guideRoute = guideRoutes(from, whiteList, true);
            next(guideRoute);
        },
    },
    {
        path: `${typeName}-OTP`,
        name: routeName.A3_OTP,
        component: () => import('@/views/otp/Index2.vue'),
        meta: {
            auth: true,
            metaTitle: '動態密碼驗證',
            leaveAlert: true,
            pageTitle: '請輸入動態密碼',
            code,
            backPage,
            unableBack: true,
        },
        beforeEnter: (to, from, next) => {
            const whiteList = [routeName.A3_CONFIRM];
            const guideRoute = guideRoutes(from, whiteList, true);
            next(guideRoute);
        },
    },
];
